// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1450M","subheader":"ReorderModal_subheader__1PgeI","listWrap":"ReorderModal_listWrap__1VhpS"};